module.exports = __webpack_public_path__ + "static/img/2_2_3_1.71f7051a.jpg";